import React from 'react'

import { useGetIdentityQuery } from '~redux/slices/apiSlice'
import { Identity0, Identity1, Identity2, IdentityId } from '~types'

interface AvatarProps {
  size: string
  src?: string | undefined
  alt?: string
  backgroundColor?: string | undefined
  identity?: Identity0 | Identity1 | Identity2
  identityId?: IdentityId
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  size,
  backgroundColor,
  identity,
  identityId,
}) => {
  const { data: queryIdentity } = useGetIdentityQuery(
    {
      identity_id: identityId,
    },
    { skip: !identityId },
  )
  const identityInfo = queryIdentity?.identity ?? identity

  if (!src && !identityInfo?.image) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '0.7rem',
          width: size,
          height: size,
          borderRadius: size,
          backgroundColor: backgroundColor || '#aaa',
          color: '#000',
        }}
      >
        {alt
          ? alt
              .split(/\s+/)
              .map((part) => part.charAt(0).toUpperCase())
              .join('')
          : ''}
      </div>
    )
  }
  if (identityInfo && identityInfo.image) {
    return (
      <img
        src={identityInfo.image}
        alt={identityInfo.name}
        style={{
          width: size,
          height: size,
          borderRadius: size,
          objectFit: 'cover',
        }}
      />
    )
  }
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: size,
        height: size,
        borderRadius: size,
        objectFit: 'cover',
      }}
    />
  )
}

export default Avatar
